import classNames from 'classnames';
import React from 'react';
import './DesignerSurface.less';

export class DesignerSurface extends React.Component<React.ComponentProps<'div'>, { hasError: boolean }> {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError(error: React.ErrorInfo) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div className="full-size flex-centering">Something went wrong.</div>;
    }

    const { className, ...otherProps } = this.props;
    return <div className={classNames('dpc-designer-surface', className)} {...otherProps}></div>;
  }
}
